import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  environment: 'preproduction',
  action: 'getMember',
  testEmail: '',
  testAcid: '',
  memberId: '',
  memberData: JSON.stringify({
    firstName: '',
    lastName: '',
    jobTitle: '',
    department: '',
    office: ''
  }, null, 2),
  tagId: '',
  userPropertyId: '',
  tagData: JSON.stringify({
    name: ''
  }, null, 2),
  groupId: '',
  groupData: JSON.stringify({
    name: '',
    description: ''
  }, null, 2),
};

export default defaults;
